import React from 'react'
import { Box, CircularProgress } from '@mui/material'
import { INTERAX_COLORS } from '../../../../constants/colors'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'

interface GroupCallEmptyStateProps {
  variant: 'loading' | 'empty'
}

export const GroupCallEmptyState: React.FC<GroupCallEmptyStateProps> = ({ variant }) => {
  const { t } = useTranslation()

  if (variant === 'loading') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px'
        }}
      >
        <CircularProgress size={36} sx={{ color: INTERAX_COLORS.sun }} />
      </Box>
    )
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        gap: '16px',
        width: '100%',
        minHeight: '200px',
        background: `${INTERAX_COLORS.heritageBlue}E6`,
        border: `1px solid ${INTERAX_COLORS.white10}`,
        boxShadow: '0px 24px 48px rgba(0, 0, 0, 0.25)',
        borderRadius: '10px'
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          maxWidth: '432px'
        }}
      >
        <Box
          sx={{
            fontSize: '18px',
            lineHeight: '28px',
            fontWeight: 500,
            color: INTERAX_COLORS.white,
            mb: '4px'
          }}
        >
          {t('gamer.groupCall.placeholder.title')}
        </Box>
        <Box
          sx={{
            fontSize: '14px',
            lineHeight: '20px',
            color: INTERAX_COLORS.typographyFont
          }}
        >
          {t('gamer.groupCall.placeholder.description')}
        </Box>
      </Box>
    </Box>
  )
}
